import React from "react";
import styled from "styled-components";
import FlexRow from "../FlexRow/FlexRow";
import { useHistory } from "react-router-dom";
import tadariss from "../../images/waves.svg";
import ArrowRight2Icon from "../../icons/ArrowRight2Icon";
import isMobile from "ismobilejs";
import ResponsiveImage from "../ResponsiveImage";
import { MENU_IMAGE_PATHS } from "../../constants/cityImages";

const Wrapper = styled.div`
  height: ${(props) => (props.open ? "100vh" : "0vh")};
  width: ${(props) => (props.open ? "100vw" : "0vw")};
  background: ${({ theme }) => theme.green};
  position: fixed;
  transition: all 0.4s;
  border-bottom-right-radius: ${(props) => (props.open ? "0px" : "1000px")};
  top: 0;
  left: 0;
  @media (max-width: 768px) {
    height: 99vh;
  }
  z-index: ${(props) => (props.open ? 100004 : -1)};

  > * {
    display: ${(props) => (props.open ? "flex" : "none")};
    opacity: ${(props) => (props.open ? "1" : "0")};
    width: 100%;
    margin: 0;
    padding: 0;
  }
  /* Override FlexRow default styling */
  > div {
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  .flexx {
    display: -webkit-flex;
    flex-direction: row;
    height: 100vh;
    width: 100% !important;
    align-items: flex-start !important;
    text-decoration: none !important;
    margin: 0;
    padding: 0;
    gap: 0;
    @media (max-width: 768px) {
      flex-direction: column;
      height: 50vh;
      gap: 60px;
    }
    &:hover {
      text-decoration: none !important;
    }
  }

  .left-content {
    width: 60%;
    height: 100vh;
    padding: 10% 5%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    @media (max-width: 768px) {
      width: 100%;
      padding: 2%;
    }
  }
  .content-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem 4rem;
    /* width: 100%; */
    margin-bottom: auto;
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 2rem;
    }
  }
  .row {
    display: -webkit-flex;
    flex-direction: column;
    align-items: flex-start;
    text-decoration: none !important;
    &:hover {
      text-decoration: none !important;
    }
  }
  .col {
    display: -webkit-flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .menu-item {
    cursor: pointer;
    transition: all 0.3s ease;
    max-width: 300px;

    &:hover {
      transform: translateY(-2px);
    }

    .menu-title {
      position: relative;
      display: inline-block;
      transition: all 0.3s ease;
    }

    .arrow-icon {
      position: absolute;
      left: -32px;
      top: 50%;
      transform: translateY(-50%) translateX(10px);
      width: 24px;
      height: 24px;
      opacity: 0;
      transition: all 0.3s ease;
      filter: brightness(0) invert(1); /* Makes the arrow white */
    }

    &:hover {
      .menu-title {
        transform: translateX(32px);
      }

      .arrow-icon {
        opacity: 1;
        transform: translateY(-50%) translateX(0px);
      }
    }

    h3 {
      font-family: ${({ theme }) => theme.fonts.ivy};
      font-size: 32px;
      font-weight: 400;
      line-height: 120%;
      letter-spacing: 0.06em;
      color: #ffffff;
      margin: 0 0 0.5rem 0;

      @media (max-width: 768px) {
        font-size: 1.2rem;
      }
    }

    .description {
      font-family: ${({ theme }) => theme.fonts.sofia};
      font-size: 14px;
      color: rgba(255, 255, 255, 0.8);
      line-height: 1.4;
      margin: 0;

      @media (max-width: 768px) {
        font-size: 0.8rem;
      }
    }
  }
  .tadariss-image {
    width: 105%;
    /* height: 100%; */
    position: absolute;
    bottom: 0;
    left: 0;

    z-index: -1;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .rightside {
    position: relative;
    width: 40%;
    height: 100vh;
    @media (max-width: 768px) {
      display: none;
    }

    img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 60;
      object-fit: cover;
    }
  }

  .close {
    position: absolute;
    left: 30px;
    top: 30px;
    width: 60px;
    height: 60px;
    background: transparent;
    cursor: pointer;
    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.white};
    z-index: 9999;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      transform: scale(1.1);
    }

    [class^="line"] {
      width: 16px;
      height: 2px;
      background: ${({ theme }) => theme.white};
      position: absolute;
      left: 50%;
      top: 50%;
    }
    .line1 {
      transform: translate(-50%, -50%) rotate(45deg);
    }
    .line2 {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }
`;

function CustomMenu({ open, setOpen, local, menuItems }) {
  const history = useHistory();

  // Get a random menu image from CDN - memoize to prevent changing on re-renders
  const randomMenuImage = React.useMemo(
    () => MENU_IMAGE_PATHS[Math.floor(Math.random() * MENU_IMAGE_PATHS.length)],
    []
  );

  const handleItemClick = (item) => {
    if (item.onClick) {
      item.onClick();
    } else if (item.path) {
      history.push(`/${local}${item.path}`);
    }
    setOpen(false);
  };

  return (
    <Wrapper open={open}>
      <FlexRow>
        <div className="flexx">
          <div className="left-content">
            <div className="content-grid">
              {menuItems &&
                menuItems.map((section, sectionIndex) =>
                  section.items.map((item, itemIndex) => (
                    <div
                      className="menu-item"
                      key={`${sectionIndex}-${itemIndex}`}
                      onClick={() => handleItemClick(item)}
                    >
                      <div className="menu-title">
                        <ArrowRight2Icon className="arrow-icon" />
                        <h3>{item.label}</h3>
                      </div>
                      <p className="description">
                        {item.description ||
                          "Discover more about this destination"}
                      </p>
                    </div>
                  ))
                )}
            </div>
            {!isMobile().phone && (
              <img src={tadariss} alt="Tadariss" className="tadariss-image" />
            )}
            <div className="close" onClick={() => setOpen(false)}>
              <div className="line1"></div>
              <div className="line2"></div>
            </div>
          </div>
          {!isMobile().phone && (
            <div className="rightside">
              <ResponsiveImage
                src={randomMenuImage}
                alt="Fes-Meknes region scenic view"
                sizes="50vw"
                loading="lazy"
              />
            </div>
          )}
        </div>
      </FlexRow>
    </Wrapper>
  );
}

export default CustomMenu;
